module.exports = __webpack_public_path__ + "img/carouselBgEn.322e34dd.png";